import { render, staticRenderFns } from "./StockMobile.vue?vue&type=template&id=0371dfc7&scoped=true&"
import script from "./StockMobile.vue?vue&type=script&lang=js&"
export * from "./StockMobile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0371dfc7",
  null
  
)

export default component.exports